import axios from 'axios'

const ExternalPaidOrderDao = {
  async loadOptions (hospitalName) {
    const { data: resp } = await axios.get('/external_paid_order/options', {
      params: { hospitalName }
    })
    if (resp.code !== 200) {
      return {
        code: 2,
        msg: resp.message
      }
    }
    return {
      code: 1,
      data: resp.data
    }
  },
  async bind (payload) {
    const { data: resp } = await axios.post('/external_paid_order/bind', payload)
    if (resp.code !== 200 || !resp.data) {
      return {
        code: 2,
        msg: resp.message
      }
    }
    return {
      code: 1,
      data: resp.data
    }
  }
}

export default ExternalPaidOrderDao
